import React from 'react';

const BuyButton = ({ label, articleNumber, name, price, variant, brand, category, quantityFieldId, href, children, cssClass, onClick }) => (
    articleNumber ? 
    <a className={cssClass}  target='_blank' onClick={() => onClick(articleNumber, name, price, variant, brand, category, quantityFieldId)}>
        {label}
    </a>
    : <a className={cssClass} target='_blank' href={href}>
        {label}
    </a>
)

export default BuyButton;